/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Draw_TitleInputs */

const en_cad_features_draw_title = /** @type {(inputs: Cad_Features_Draw_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draw anything from lines to splines`)
};

/**
* | output |
* | --- |
* | "Draw anything from lines to splines" |
*
* @param {Cad_Features_Draw_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_draw_title = /** @type {((inputs?: Cad_Features_Draw_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Draw_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_draw_title(inputs)
});
export { cad_features_draw_title as "cad.features.draw_title" }